import Cookies from 'js-cookie';
import { useCallback } from 'react';

import { useReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';
import { AppleWallet } from '@eika-infrastruktur/mobilbank-lib/src/nativeProps';

const PENDING_COOKIE_NAME = 'pending_cards';

const jsonStringifyPendingCards = (appleWallet: AppleWallet | undefined) =>
    JSON.stringify(
        appleWallet?.pendingCardTokens.map(
            (pendingCard) => pendingCard.tokenUniqueReference.value + pendingCard.primaryAccountIdentifier.value,
        ) ?? [],
    );

const usePendingCardTokenCookies = () => {
    const { appleWallet } = useReactNativeProps();
    const showModal =
        Cookies.get(PENDING_COOKIE_NAME) !== jsonStringifyPendingCards(appleWallet) ||
        Cookies.get(PENDING_COOKIE_NAME) === undefined;

    const setCookies = useCallback(
        (isSuccess: boolean) => {
            if (!isSuccess) {
                Cookies.set(PENDING_COOKIE_NAME, jsonStringifyPendingCards(appleWallet));
            }
        },
        [appleWallet],
    );

    return { showModal, setCookies };
};

export default usePendingCardTokenCookies;
